import React, {Component} from "react";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Icon, Spin} from "antd";
import {MDBDataTable} from "mdbreact";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import axiosTags from "../../../../axios/axios_tag";
import apiConfig from "../../../../axios/axios_api_services";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import UploadCSV from "../CreateUser/UploadCSV/UploadCSV";


class App extends Component {
  state = {
    isSpin: false,
    VIPContent: []
  };

  componentDidMount() {
    this.loadVIPTable();
  }

  loadVIPTable = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.LOAD_VIP_USERS, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          console.log(response)
          //   common.warningAlert("User details successfully saved", 0);
          this.setState({VIPContent: response.data.body})
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.submitForm()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  reloadBtn = (val) => {
    if (val){
      this.loadVIPTable();
    }
  };

  render() {
    let rows = this.state.VIPContent;
    let columns = [
      {
        label: 'User Id',
        field: 'userId',
        sort: 'asc'
      }, {
        label: 'First Name',
        field: 'firstName',
        sort: 'asc'
      },
      {
        label: 'Last Name',
        field: 'lastName',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'
      },
      {
        label: 'Mobile',
        field: 'mobile',
        sort: 'asc'
      },
      {
        label: 'VIP Points',
        field: 'points',
        sort: 'asc'
      },

    ];
    let table_data = {columns, rows};
    return (
      <div>
        {
          this.state.usersUploadCSV ?
            <UploadCSV isVIPflow={true} successReload={(value) => this.reloadBtn(value)} departmentArray={rows}
                       closeModal={() => {
                         this.setState({usersUploadCSV: false})
                       }}/> : null
        }
        <div className={"top-buttons-wrapper"}>
          <button className={"sync-azure-btn upload-users-csv"} onClick={() => {
            this.setState({usersUploadCSV: true})
          }}>Upload users via CSV file &nbsp; <Icon name={"users"}/></button>
          {/*<button className={"sync-azure-btn"} onClick={this.syncUsersFromAzureHandler}>Sync users from azure &nbsp;*/}
          {/*  <Icon name={"users"}/>*/}
          {/*</button>*/}
        </div>
        <Row>
          <Col lg='12'>
            <Card>
              <CardHeader>
                VIP Users Details
              </CardHeader>
              <CardBody>

                <Spin spinning={this.state.isSpin} delay={10}
                      indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                  <MDBDataTable
                    id={"all-corporate-table"}
                    searching={true}
                    searchLabel={"Search Corporate User"}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    // striped={true}
                    bordered
                    hover
                    data={table_data}/>
                </Spin>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.COPUserReducer.view_all_corporates_users, //not use
  corporate_headers: state.COPUserReducer.corporate_user_headers,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    getAllCorporateUsers: (data) => dispatch(actionCreator.getAllCorporateUsers(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
